import { buildAnalyzerMessage } from '../services/ai.js';

export function handleAnalyzerMessage() {
  const contractAddress = prompt("Enter the token contract address to analyze:");
  
  if (contractAddress) {
    window.logToConsole("🔍 AI Token Scan analyzing contract...");
    
    buildAnalyzerMessage(contractAddress).then(msg => {
      window.logToConsole(`🔍 TOKEN ANALYSIS:\n${msg}`);
    }).catch(error => {
      console.error("Analyzer error:", error);
      window.logToConsole("🔍 ERROR: Could not analyze contract.");
    });
  }
}